import { APP_NAME } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const type = icon ? "icon" : "logo";
  const sizeClassName = icon ? "mx-auto w-9" : small ? "h-4 w-auto" : "h-5 w-auto";

  // Each theme gets its own asset variant instead of `dark:invert`, so two-color brand logos keep their accent color.
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        <img
          className={classNames(sizeClassName, "dark:hidden")}
          alt={APP_NAME}
          title={APP_NAME}
          src={`${src}?type=${type}`}
        />
        <img
          className={classNames(sizeClassName, "hidden dark:block")}
          alt={APP_NAME}
          title={APP_NAME}
          src={`${src}?type=${type}-dark`}
        />
      </strong>
    </h3>
  );
}
